import { createContext, useContext, Dispatch } from 'react';

import { LegalEntityActionType, LegalEntityActions, LegalEntityStateType } from '../../types';

import { initialState } from './reducer';

type StoreType = {
  state: LegalEntityStateType;
  dispatch: Dispatch<LegalEntityActionType>;
  actions: LegalEntityActions;
};

export const LegalEntityListContext = createContext<StoreType>({
  state: initialState,
  dispatch: () => {},
  actions: {
    setLegalEntities: () => {},
    setLoadingLegalEntities: () => {},
    searchByName: () => {},
    searchByAccount: () => {},
    setAccounts: () => {},
    setSelectedLegalEntities: () => {},
    paginate: () => {},
  },
});

export const useLegalEntityListContext = (): StoreType => useContext(LegalEntityListContext);
